<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh
                            v-if="scrap_authorization.scrap_auth_id && scrap_authorization.scrap_auth_id > 0"
                            @invoke-method="dbGetScrapAuthorization(true)"
                        ></bc-btn-refresh>
                        <v-menu left content-class="no-stripe" v-if="scrap_authorization.scrap_auth_id && scrap_authorization.scrap_auth_id > 0">
                            <template slot="activator">
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile @click="printPDF()">
                                    <v-list-tile-title> Print </v-list-tile-title>
                                </v-list-tile>
                                <template v-if="hasPerm('scrap_authorizations.update')">
                                    <v-divider class="ml-3 my-0"></v-divider>

                                    <div v-for="item in scrap_authorization_status_options" :key="item.option_id">
                                        <v-list-tile @click="changeStatus(item)" v-if="item.option_id != scrap_authorization.status_id">
                                            <v-list-tile-title>
                                                {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </div>
                                </template>
                                <template v-if="hasPerm('scrap_authorizations.delete')">
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="$refs.delete_scrap_authorization.openDialog()">
                                        <v-list-tile-title> Delete </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu>
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'scrap_authorizations' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>

            <v-card-text>
                <v-card elevation="10">
                    <v-card-text>
                        <div v-if="scrap_authorization.status" class="ribbon ribbon-top-right" :class="`ribbon-${scrap_authorization.status_class}`">
                            <span class="ribbon-span">{{ scrap_authorization.status }}</span>
                        </div>
                        <v-form ref="formScrapAuthorization">
                            <v-flex xs12>
                                <v-text-field
                                    v-focus="scrap_authorization_dialog"
                                    v-model="scrap_authorization.scrap_auth_id"
                                    :label="`${$t('lang.scrap_auth_id')} *`"
                                    :counter="showCounter(scrap_authorization.scrap_auth_id, 'scrap_authorizations.scrap_auth_id')"
                                    :rules="ifValid('scrap_authorizations.scrap_auth_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="scrap_authorization.nonconformance_id"
                                    :label="$t('lang.nonconformance_id')"
                                    :items="nonconformance"
                                    item-value="nonconformance_id"
                                    item-text="nonconformance_id"
                                    :rules="ifValid('scrap_authorizations.nonconformance_id')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <bc-select
                                    v-model="scrap_authorization.corrective_action"
                                    :label="`${$t('lang.corrective_action')} *`"
                                    :items="[]"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('scrap_authorizations.corrective_action')"
                                ></bc-select>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="scrap_authorization.car_number"
                                    :label="$t('lang.car_number')"
                                    :counter="showCounter(scrap_authorization.car_number, 'scrap_authorizations.car_number')"
                                    :rules="ifValid('scrap_authorizations.car_number')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="scrap_authorization.company_id"
                                    :label="$t('lang.company_id')"
                                    :items="customers"
                                    item-value="company_id"
                                    item-text="company"
                                    :rules="ifValid('scrap_authorizations.company_id')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="scrap_authorization.part_id"
                                    :label="$t('lang.part_id')"
                                    :items="parts"
                                    item-value="part_id"
                                    item-text="part_id"
                                    :rules="ifValid('scrap_authorizations.part_id')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="scrap_authorization.batch_id"
                                    :label="$t('lang.batch_id')"
                                    :items="work_orders_batches"
                                    item-value="batch_id"
                                    item-text="batch_id"
                                    :rules="ifValid('scrap_authorizations.batch_id')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="scrap_authorization.quality_mgr_id"
                                    :label="$t('lang.quality_mgr_id')"
                                    :items="quality_mgr_id"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('scrap_authorizations.quality_mgr_id')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <bc-date-picker
                                    v-model="scrap_authorization.quality_mgr_date"
                                    :label="$t('lang.quality_mgr_date')"
                                    :rules="ifValid('scrap_authorizations.quality_mgr_date')"
                                ></bc-date-picker>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="scrap_authorization.sales_mgr_id"
                                    :label="$t('lang.sales_mgr_id')"
                                    :items="sales_mgr_id"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('scrap_authorizations.sales_mgr_id')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <bc-date-picker
                                    v-model="scrap_authorization.sales_mgr_date"
                                    :label="$t('lang.sales_mgr_date')"
                                    :rules="ifValid('scrap_authorizations.sales_mgr_date')"
                                ></bc-date-picker>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="scrap_authorization.ehs_mgr_id"
                                    :label="$t('lang.ehs_mgr_id')"
                                    :items="ehs_mgr_id"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('scrap_authorizations.ehs_mgr_id')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <bc-date-picker
                                    v-model="scrap_authorization.ehs_mgr_date"
                                    :label="$t('lang.ehs_mgr_date')"
                                    :rules="ifValid('scrap_authorizations.ehs_mgr_date')"
                                ></bc-date-picker>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="scrap_authorization.production_mgr_id"
                                    :label="$t('lang.production_mgr_id')"
                                    :items="production_mgr_id"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('scrap_authorizations.production_mgr_id')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <bc-date-picker
                                    v-model="scrap_authorization.production_mgr_date"
                                    :label="$t('lang.production_mgr_date')"
                                    :rules="ifValid('scrap_authorizations.production_mgr_date')"
                                ></bc-date-picker>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="scrap_authorization.executive_id"
                                    :label="$t('lang.executive_id')"
                                    :items="executive_id"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('scrap_authorizations.executive_id')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <bc-date-picker
                                    v-model="scrap_authorization.executive_date"
                                    :label="$t('lang.executive_date')"
                                    :rules="ifValid('scrap_authorizations.executive_date')"
                                ></bc-date-picker>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="scrap_authorization.qty_scrapped"
                                    :label="`${$t('lang.qty_scrapped')} *`"
                                    :counter="showCounter(scrap_authorization.qty_scrapped, 'scrap_authorizations.qty_scrapped')"
                                    :rules="ifValid('scrap_authorizations.qty_scrapped')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="scrap_authorization.rma_number"
                                    :label="$t('lang.rma_number')"
                                    :counter="showCounter(scrap_authorization.rma_number, 'scrap_authorizations.rma_number')"
                                    :rules="ifValid('scrap_authorizations.rma_number')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="scrap_authorization.part_cost_estimate"
                                    :label="$t('lang.part_cost_estimate')"
                                    :counter="showCounter(scrap_authorization.part_cost_estimate, 'scrap_authorizations.part_cost_estimate')"
                                    :rules="ifValid('scrap_authorizations.part_cost_estimate')"
                                ></v-text-field>
                            </v-flex>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @mouseup.left="$router.push({ name: 'scrap_authorizations' })" flat>{{ $t("lang.cancel") }}</v-btn>
                        <v-btn color="success" @click="saveScrapAuthorizations">{{ $t("lang.save") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>

            <delete-confirmation-dialog
                ref="delete_scrap_authorization"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_scrap_authorization')"
                :message="$t('lang.delete_scrap_authorization_confirm')"
                @onConfirm="deleteScrapAuthorizations()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_scrap_authorization_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteScrapAuthorizationDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            scrap_authorization: {},
            file_name: "",
            dbGetScrapAuthorization: _.debounce(this.getScrapAuthorization, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
            scrap_authorization_dialog: false,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchScrapAuthorization", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.scrap_authorization) {
                        this.scrap_authorization = this.assignObj2(data.scrap_authorization, this.rules_scrap_authorizations);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=scrap_authorization_status&sort_by=2",
                            method: "get",
                            stateProperty: "scrap_authorization_status_options",
                            dataProperty: "options",
                            commit: true,
                        });

                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "scrap_authorizations", replace: true });
                    }
                });
        } else {
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchScrapAuthorization", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.scrap_authorization) {
                        next((vm) => {
                            vm.scrap_authorization = vm.assignObj2(data.scrap_authorization, vm.rules_scrap_authorizations);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=scrap_authorization_status&sort_by=2",
                                method: "get",
                                stateProperty: "scrap_authorization_status_options",
                                dataProperty: "options",
                                commit: true,
                            });

                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "scrap_authorizations", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=scrap_authorization_status&sort_by=2",
            method: "get",
            stateProperty: "scrap_authorization_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_scrap_authorizations: (state) => state.scrap_authorizations.rules_scrap_authorizations,
            scrap_authorization_status_options: (state) => state.settings.scrap_authorization_status_options,
            scrap_authorizations: (state) => state.scrap_authorizations.scrap_authorizations,
            selectedScrapAuthorization: (state) => state.scrap_authorizations.selectedScrapAuthorization,
            nonconformance: (state) => state.nonconformance.nonconformance,
            parts: (state) => state.parts.parts,
            work_orders_batches: (state) => state.work_orders_batches.work_orders_batches,
        }),
    },
    methods: {
        ...mapActions([
            "fetchScrapAuthorization",
            "saveScrapAuthorization",
            "deleteScrapAuthorization",
            "printScrapAuthorization",
            "fetchNonconformance",
            "fetchCustomers",
            "fetchParts",
            "fetchWorkOrdersBatches",
        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),

        getScrapAuthorization(pg_refresh = false) {
            this.startLoader();

            this.fetchScrapAuthorization({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.scrap_authorization) {
                    this.scrap_authorization = this.assignObj2(data.scrap_authorization, this.rules_scrap_authorizations);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printScrapAuthorization({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.scrap_authorization) {
                    if (this.dev_mode) {
                        this.file_name = data.scrap_authorization.file_name;
                    } else {
                        this.$refs.print.printReport(data.scrap_authorization.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveScrapAuthorizations() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formScrapAuthorization")) {
                    let body = this.prepForm(this.scrap_authorization, this.rules_scrap_authorizations);

                    this.saveScrapAuthorization({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.scrap_authorization) {
                            this.$router.push({ name: "scrap_authorization", params: { id: data.scrap_authorization.scrap_auth_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { scrap_auth_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveScrapAuthorizations({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.scrap_authorization) {
                    this.scrap_authorization = this.assignObj2(data.scrap_authorization, this.rules_scrap_authorizations);
                }
            });
        },
        deleteScrapAuthorizations() {
            this.deleteScrapAuthorization({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                console.log(data);
                if (data && data.code == "200") {
                    this.validationOff();
                    this.$router.push({ name: "scrap_authorizations" });
                }
                this.toggleModalLoader(false);
            });
        },
        async refresh(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchScrapAuthorization({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.scrap_authorization) {
                        this.scrap_authorization = this.assignObj2(data.scrap_authorization, this.rules_scrap_authorizations);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }

            if (this.nonconformance.length == 0 || force == true) await this.fetchNonconformance({ body: { options: 1 } });
            if (this.customers === null || force == true) await this.getCustomers();
            if (this.parts.length == 0 || force == true) await this.fetchParts({ body: { options: 1 } });
            if (this.work_orders_batches.length == 0 || force == true) await this.fetchWorkOrdersBatches({ body: { options: 1 } });
        },
    },
    mounted() {
        this.refresh();
    },
    created() {},
};
</script>
